import { INSTANT_SEARCH_ATTRIBUTES } from 'constants/instantSearch'

export const getInstantSearchHierarchicalAttributesLvs = () => {
  const { CATEGORIES_LV0, CATEGORIES_LV1, CATEGORIES_LV2 } = INSTANT_SEARCH_ATTRIBUTES['en-hk']

  return [CATEGORIES_LV0.attr, CATEGORIES_LV1.attr, CATEGORIES_LV2.attr]
}
